import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Festify() {
	const canvasRef = useRef(null);
	const [formData, setFormData] = useState({ name: "", email: "", message: "" });
	const [status, setStatus] = useState({ submitting: false, success: false, error: null });

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus({ submitting: true, success: false, error: null });

		try {
			const response = await fetch("https://week.token2049.com/api/contact", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(formData),
			});

			if (!response.ok) throw new Error("Failed to submit");

			setStatus({ submitting: false, success: true, error: null });
			setFormData({ name: "", email: "", message: "" });
		} catch (err) {
			setStatus({ submitting: false, success: false, error: err.message });
		}
	};

	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext("2d");
		let particles = [];

		const resize = () => {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		};

		window.addEventListener("resize", resize);
		resize();

		for (let i = 0; i < 100; i++) {
			particles.push({
				x: Math.random() * window.innerWidth,
				y: Math.random() * window.innerHeight,
				radius: Math.random() * 2,
				dx: (Math.random() - 0.5) * 0.5,
				dy: (Math.random() - 0.5) * 0.5,
			});
		}

		const animate = () => {
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			particles.forEach((p) => {
				p.x += p.dx;
				p.y += p.dy;

				if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
				if (p.y < 0 || p.y > canvas.height) p.dy *= -1;

				ctx.beginPath();
				ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
				ctx.fillStyle = "rgba(0,0,0,0.3)";
				ctx.fill();
			});

			requestAnimationFrame(animate);
		};

		animate();

		return () => window.removeEventListener("resize", resize);
	}, []);

	return (
		<div className="min-h-screen w-full bg-white text-gray-900 flex flex-col items-center justify-center p-8 relative overflow-hidden">
			<canvas ref={canvasRef} className="absolute inset-0 w-full h-full"></canvas>
			<div className="max-w-4xl w-full text-center z-10">
				<motion.div
					initial={{ opacity: 0, y: -10 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5 }}
					className="mb-6 text-2xl font-semibold text-gray-800 relative inline-block"
				>
					Festify
					<div className="absolute left-0 right-0 -bottom-1 h-0.5 bg-gray-800 rounded-full"></div>
				</motion.div>
				<motion.h1
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
					className="text-4xl md:text-5xl font-bold mb-4"
				>
					The ultimate tech partner for distinguished events.
				</motion.h1>
				<motion.p
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto"
				>
					We blend innovation and seamless execution to deliver next-gen event experiences — all in one place.
				</motion.p>
				<motion.div
					initial={{ opacity: 0, scale: 0.95 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ duration: 1 }}
					className="bg-gray-100 p-8 rounded-2xl shadow-xl max-w-md mx-auto"
				>
					<form className="space-y-4" onSubmit={handleSubmit}>
						<input
							type="text"
							name="name"
							placeholder="Your Name"
							required
							value={formData.name}
							onChange={handleChange}
							className="w-full p-3 rounded-lg border border-gray-300"
						/>
						<input
							type="email"
							name="email"
							placeholder="Your Email"
							required
							value={formData.email}
							onChange={handleChange}
							className="w-full p-3 rounded-lg border border-gray-300"
						/>
						<textarea
							name="message"
							placeholder="Your Message / Event Requirement"
							rows="3"
							required
							value={formData.message}
							onChange={handleChange}
							className="w-full p-3 rounded-lg border border-gray-300"
						></textarea>
						<button
							type="submit"
							disabled={status.submitting}
							className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-900 disabled:bg-gray-400"
						>
							{status.submitting ? "Submitting..." : "Submit Inquiry"}
						</button>
						{status.success && <p className="text-green-600 text-sm">Message sent successfully!</p>}
						{status.error && <p className="text-red-600 text-sm">Error: {status.error}</p>}
					</form>
				</motion.div>
				<footer className="text-center text-sm text-gray-500 mt-8">© 2025 Festify. All Rights Reserved.</footer>
			</div>
		</div>
	);
}
